import { render, staticRenderFns } from "./priceListDataCell.vue?vue&type=template&id=1b171204&"
import script from "./priceListDataCell.vue?vue&type=script&lang=js&"
export * from "./priceListDataCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports